module.exports = __webpack_public_path__ + "50080b0deb98abf844e72d60f9e4c806.svg";